module.exports = __webpack_public_path__ + "img/product_66.157616a.svg";